/** Información progresiva del pago por transferencia. */

import type { DatosTransferenciaReserva } from '@/infra/contratos';
import { Aviso } from '@/publico/componentes/Aviso';

export function AvisoTransferenciaPendiente(): React.JSX.Element {
  return (
    <Aviso tono="info" titulo="Pago por transferencia">
      <p>
        Los datos para realizar la transferencia se mostrarán cuando la reserva quede confirmada.
      </p>
    </Aviso>
  );
}

export function DatosTransferenciaConfirmada({
  datos,
}: {
  readonly datos: DatosTransferenciaReserva;
}): React.JSX.Element {
  const mensaje = 'Hola, envío el comprobante de transferencia de mi reserva en M&M Pádel.';
  const enlaceComprobante = `https://wa.me/${datos.telefonoWhatsapp}?text=${encodeURIComponent(
    mensaje,
  )}`;

  return (
    <section aria-labelledby="transferencia-confirmada-titulo" className="transferencia-confirmada">
      <h3 className="transferencia-confirmada__titulo" id="transferencia-confirmada-titulo">
        Datos para realizar la transferencia
      </h3>

      <dl className="transferencia-confirmada__datos">
        <div>
          <dt>Banco</dt>
          <dd>{datos.banco}</dd>
        </div>
        <div>
          <dt>Número de cuenta</dt>
          <dd className="transferencia-confirmada__cuenta">{datos.numeroCuenta}</dd>
        </div>
        <div>
          <dt>Nombre</dt>
          <dd>{datos.nombreTitular}</dd>
        </div>
      </dl>

      <p className="transferencia-confirmada__comprobante">
        El comprobante de transferencia se debe enviar por WhatsApp al{' '}
        <a href={enlaceComprobante} rel="noopener noreferrer" target="_blank">
          {datos.telefonoComprobante}
        </a>
        .
      </p>
    </section>
  );
}
